export default __webpack_public_path__ + "static/media/icons_activities.c8055563.svg";